import { StoreName } from "../../decorators/StoreNameDecorator";
import { BatchClassConfig } from "../../models/config/BatchClassConfig";
import { BatchClassMetadataData } from "../../models/config/BatchClassMetadata";
import BatchClassRoleViewModel from "../../models/viewmodels/BatchClassRoleViewModel";
import { BatchClassRoleViewModelStore } from "./BatchClassRoleViewModelStore";

@StoreName("BatchClassRoleStore")
class BatchClassRoleStoreClass {
  private stores: Map<
    string,
    BatchClassRoleViewModelStore<number, BatchClassRoleViewModel>
  >;

  constructor() {
    this.stores = new Map();
  }

  getBatchClassStore(
    batchClass:
      | BatchClassConfig
      | BatchClassRoleViewModel
      | string
      | BatchClassMetadataData,
  ): BatchClassRoleViewModelStore<number, BatchClassRoleViewModel> {
    let batchClassId: string = "";

    if (this.isString(batchClass)) {
      batchClassId = batchClass;
    } else {
      batchClassId = batchClass.batchClassId;
    }

    if (!this.stores.has(batchClassId)) {
      this.stores.set(
        batchClassId,
        new BatchClassRoleViewModelStore(batchClassId),
      );
    }
    return this.stores.get(batchClassId)!;
  }

  getAllStores() {
    return Array.from(this.stores.values());
  }

  private isString(value: any): value is string {
    return typeof value === "string";
  }
}

const BatchClassRoleStore = new BatchClassRoleStoreClass();
export { BatchClassRoleStore };
